import React, { useContext } from "react";
import { Accordion } from "react-bootstrap";
import { Link } from "react-router-dom";
import useAds from "../../hooks/UseAds";
import start from "../../assets/img/start.gif";
import { LocationContext } from "../../contexts";
import { TargetsContext } from "../../contexts";

export const Home = () => {
  useAds();
  const location = useContext(LocationContext);
  const targets = useContext(TargetsContext);

  const getTargetOrdinal = (id) => {
    for (let n = 0; n < targets.length; ++n) {
      if (targets[n].id === id) return n;
    }
  };

  const getTarget = (sourceCountry, sourceContinent) => {
    // Look for a country match in targets.
    let found = targets.find((target) => target.countryCode.toUpperCase() === sourceCountry);
    if (found) {
      return getTargetOrdinal(found.id);
    }

    // Look for a continent match in targets.
    found = targets.find((target) => target.continentCode.toUpperCase() === sourceContinent);
    if (found) {
      return getTargetOrdinal(found.id);
    }

    return 0;
  };

  const getBestTarget = () => {
    let sourceContinent = location.continent.toUpperCase();
    let sourceCountry = location.country.toUpperCase();

    switch (sourceContinent) {
      case "SA":
        sourceContinent = "NA";
        break;
      case "AN":
        sourceContinent = "AF";
        break;
      case "":
        sourceContinent = "NA";
        break;
      default:
    }

    if (!sourceCountry || sourceCountry === "") {
      sourceCountry = "US";
    }

    //    return getTarget("JP", "AS");

    return getTarget(sourceCountry, sourceContinent);
  };

  // Render.

  return (
    <>
      <h1 className='mt-4'>Do You Lag?</h1>

      <div className='p-3'>Don't be that person. In just 5 seconds you can test your Latency.</div>

      <div className='d-flex justify-content-center my-5'>
        <Link id='begin-speed-test' to={`/detail-testing/${getBestTarget()}`}>
          <img src={start} className='img-fluid' alt='...' />
        </Link>
      </div>

      <Accordion className='text-start'>
        <Accordion.Item eventKey='0'>
          <Accordion.Header>Bandwidth and Latency</Accordion.Header>
          <Accordion.Body>
            Let’s use an analogy of a highway. Bandwidth is the number of lanes on the highway. So, an 16-lane highway
            has more capacity or can handle more traffic than a 2-lane highway. The higher the bandwidth (lanes), the
            more traffic can move from one location to another during a specific timeframe. Bandwidth is the most used
            value for internet speed but it really measures the volume of information that can be transferred over a
            connection in a set amount of time (i.e. 80 Mbps Download and 10 Mbps Upload speed). Latency is a measure of
            how fast the cars travel on the highway. It is usually measured in milliseconds (ms). The lower the Latency
            value, the better your speed. It is a measure of how fast a packet of information goes between your location
            to a specific server.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey='1'>
          <Accordion.Header>Jitter</Accordion.Header>
          <Accordion.Body>
            Jitter measures stability or the VARIATION, over time, of Latency. Data packets are sent in a continuous
            steady stream and are spaced evenly apart. But unforeseen issues like network congestion may alter this
            steady stream, or the delay between each packet can fluctuate instead of remaining constant. Kind of like
            rush hour traffic in Los Angeles. You may have experienced these problems on a VOIP or video conference if
            you lose a connection for a second or more. You want a stable connection or low Jitter.
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey='2'>
          <Accordion.Header>Ping</Accordion.Header>
          <Accordion.Body>
            Ping, which has its roots in active sonar (think submarine movies), is the signal transmitted across the
            network to another computer. This other computer then sends its own signal back, which is another ping. The
            signal is the ping. Think of Ping as a car. And the measurement of the car’s round trip is Latency.
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </>
  );
};
